import { SecurityResolutionDetailsRequest } from '@ddt-web/wealth-web';

import { FundTagConfig, FundTagGroupConfig } from '../models/fund-tag-config.interface';
import { FundTagData } from '../models/fund-tags.interface';


export class FundTagUtil {
	public static buildSelectedTags(supportedFundTags: FundTagGroupConfig[], tags: string[]): { [groupId: string]: string[] } {
		const selectedTags = {};

		supportedFundTags.forEach((tagGroup: FundTagGroupConfig) => {
			selectedTags[tagGroup.id] = tagGroup.tags.map(tag => tag.id).filter(tagInGroup => tags.includes(tagInGroup));
		});

		return selectedTags;
	}

	public static buildTagLabels(selectedTags: { [groupId: string]: string[] }, tagConfigs: FundTagConfig[]): string[] {
		return [].concat(...Object.values(selectedTags)).map((tag: string) => tagConfigs.find(tagConfig => tagConfig.id === tag)?.label);
	}

	/**
	 * Creates a SecurityResolutionDetailsRequest object from FundTagData.
	 * Fund tags will not be filtered if not passed
	 */
	public static buildSecurityParamFromTags(fundTags: FundTagData[], tags?: string[]): SecurityResolutionDetailsRequest {
		const securities = fundTags
			.filter(fund => tags ? fund.tags.some(tag => tags.indexOf(tag) >= 0) : fund)
			.map(fund => {
				return {
					id: fund.clientId,
					identifiers: {
						morningstarSecId: fund.morningstarSecId,
						// clientId needs to be assigned to the globalId key because mapSecurityResolutionDetailsRequestToSecurityResolutionRequest translates globalId to clientId before the request is sent
						globalId: fund.clientId,
						cusip: fund.cusip
					}
				};
			});

		return { securities };
	}

	/**
	 * globalId is later re-translated to clientId - setting globalId as shared code is set to handle that
	 */
	public static setGlobalIdFromClientId(funds: FundTagData[]): FundTagData[] {
		return funds.map(fund => ({ ...fund, globalId: fund.clientId }));
	}
}
